/* eslint-disable prettier/prettier */
/**
 * Assertions.js
 * Created by calhosh on 11/6/2019.
 */

import React, {useState} from 'react';
import styled from 'styled-components';
import Assertion from './Assertion';
import {labels} from '../../../util/utils';
import {AccountType} from '../../../util/uiconstants';
import CreateEditAccountModalWrapper from '../EntityCrud/CreateEditAccountModalWrapper';
import ResourceWithLink from '../ResourceWithLink/ResourceWithLink';

function Assertions(props) {
	const {
		assertions,
		isActive,
		showName,
		showAssertionName,
		displayName,
		showCheckbox,
		checkboxDisabled,
		onCheckboxChange,
		showExpandCollapse,
		noBackground,
		showAddedLabel,
		isAddTaskModal,
		showAbbreviationTooltipOnly,
		accountTypeId,
		accountId,
		onEditAccountClick,
		inherentRiskView,
		excludeAccountModal = false
	} = props;

	const [currentAssertionId, setCurrentAssertionId] = useState(undefined);
	const [isManageAccountsModalOpen, setIsManageAccountsModalOpen] = useState(false);

	const accountTypeLabels = {
		[AccountType.Significant]: labels.noAssertionFound,
		[AccountType.LimitedRisk]: labels.limitedRiskAccountIdentifier,
		[AccountType.InSignificant]: labels.insignificantAccountIdentifier,
		[AccountType.Others]: labels.noAssertionFound,
		[AccountType.SignificantDisclosure]: labels.noAssertionFound
	};

	const showEditAccountModalClick = () => {
		setIsManageAccountsModalOpen(true);
		onEditAccountClick(true, accountId);
	};

	const onClick = (assertionId) => {
		if (props.onClick) {
			props.onClick();
		}
		setCurrentAssertionId(assertionId);
	};

	return (
		<Wrapper className={`assertions-group-list ${showAssertionName ? 'shownAssertionName' : 'HiddenAssertionName'}`}>
			{assertions && assertions.length > 0 ? (
				assertions.map((assertion, i) => {
					return (
						<Assertion
							key={'assertion' + assertion.id + i}
							isActive={isActive && assertion.id === currentAssertionId}
							assertion={assertion}
							isExpanded={false}
							showName={showName}
							showAssertionName={showAssertionName}
							showExpandCollapse={showExpandCollapse}
							onClick={onClick}
							displayName={displayName}
							showCheckbox={showCheckbox}
							inherentRiskTypeId={assertion.inherentRiskTypeId}
							inherentRiskView={inherentRiskView}
							checked={assertion.checked}
							checkboxDisabled={checkboxDisabled}
							onCheckboxChange={onCheckboxChange}
							noBackground={noBackground}
							showAddedLabel={showAddedLabel}
							isAddTaskModal={isAddTaskModal}
							showAbbreviationTooltipOnly={showAbbreviationTooltipOnly}
						/>
					);
				})
			) : (
				<>
					{assertions && assertions.length === 0 && (
						<>
							{accountTypeLabels[accountTypeId] && (
								<ResourceWithLink
									className="emptyContainer"
									onPlaceholderClickConfig={{here: showEditAccountModalClick}}
									placeholder={accountTypeLabels[accountTypeId]}
								/>
							)}
							{isManageAccountsModalOpen && !excludeAccountModal && (
								<CreateEditAccountModalWrapper
									isEdit={true}
									showModal={isManageAccountsModalOpen}
									setShowModal={setIsManageAccountsModalOpen}
									accountId={accountId}
								/>
							)}
						</>
					)}
				</>
			)}
		</Wrapper>
	);
}

export default Assertions;

const Wrapper = styled.ul`
	&.shownAssertionName {
		width: 100%;
		.assertion-item {
			width: 100%;
		}
	}
`;
